export default __webpack_public_path__ + "locales/ko-KR/SalesDepartmentRequestDialog.json?hash=aa3103f0999b4383271abaa09a0d9ee1";